module.exports = __webpack_public_path__ + "img/walls.1a9a7146.png";